import { MasterHelper } from './../../utilities/master-helper';
export class DateRangeView {
  startDate: Date;
  endDate: Date;

  constructor() {
    this.startDate = MasterHelper.getDate(0);
    this.endDate = MasterHelper.getDate(90);
  }
}
